import {CommonModule} from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output,
    viewChildren,
} from '@angular/core';
import {DateShortYearPipe, NumberPipe} from '@brunata-angular/ui';
import {applySortingToHeaders, SortableTableHeaderComponent, Sorting} from '@brunata-angular/ui';
import {ConsumptionReportDetails} from '../../types/consumption-report.model';
import {TranslatePipe} from '@brunata-angular/util';

@Component({
    selector: 'app-location-table',
    standalone: true,
    imports: [
        CommonModule,
        TranslatePipe,
        DateShortYearPipe,
        SortableTableHeaderComponent,
        NumberPipe,
    ],
    templateUrl: './location-table.component.html',
    styleUrl: './location-table.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LocationTableComponent {
    private readonly headers = viewChildren(SortableTableHeaderComponent);
    @Input({required: true}) view!: ConsumptionReportDetails[];
    @Input({required: true}) page = 1;
    @Input({required: true}) pageSize = 10;
    @Output() sorting: EventEmitter<Sorting> = new EventEmitter<Sorting>();

    onSort(sorting: Sorting): void {
        applySortingToHeaders(this.headers(), sorting);
        this.sorting.emit(sorting);
    }
}
